import { useState } from "react";

const useFileUpload = (uploadApi, key = 'file') => {
	const [file, setFile] = useState(null);

	const handleUpload = async (params) => {
		if (!file) return null;
		const formData = new FormData();
		formData.append(key, file, file.name);
		return await uploadApi(params, formData);
	};

	const reset = () => setFile(null);

	return {
		file,
		setFile,
		onUpload: handleUpload,
		reset,
	};
};

export default useFileUpload;
